import { render, staticRenderFns } from "./StatsOverlay.vue?vue&type=template&id=ed6c7fa2&scoped=true"
import script from "./StatsOverlay.vue?vue&type=script&lang=js"
export * from "./StatsOverlay.vue?vue&type=script&lang=js"
import style0 from "./StatsOverlay.vue?vue&type=style&index=0&id=ed6c7fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6c7fa2",
  null
  
)

export default component.exports